<template>
  <div style="padding: 0 10px;">
    <vue-easy-print ref="easyPrint" table-show>
      <h1 style="text-align:center">收款说明函</h1>
      <p>致{{ form.groupName }}：</p>
      <p>
        本人<span class="underline">{{ form.driverName }}</span>(身份证号码:<span class="underline minWidth">{{ form.driverIdNumber }}</span>手机号码:
        <span class="underline minWidth">{{ form.driverPhone }}</span>)接受<span class="underline">{{ form.leaderName }}</span>(身份证号码:
        <span class="underline minWidth">{{ form.leaderIdNumber }}</span>手机号码:<span class="underline minWidth">{{ form.leaderPhone }}</span>)
        的委托，承接指定运单并代收指定运单对应的运费款项。运单交易完成后，本人同意将代收运费款项全额转至被<span class="underline">{{ form.leaderName }}</span>
        指定账户。代收过程中，本人的一切行为均代表本人，与本人的行为具有同等法律效力。依据本说明函进行的代收运费款项划转所引起的一切法律纠纷或风险，由本人独立承担或解决。
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <P>
        收款开户人姓名：<span class="underline minWidth">{{ form.bankPersonName }}</span>
      </P>
      <P>
        <span style="letter-spacing:1em;">收款账</span>号：<span class="underline minWidth">{{ form.bankAccount }}</span>
      </P>
      <P>
        <span style="letter-spacing:2em;">开户</span>行：<span class="underline minWidth">{{ form.bankName }}</span>
      </P>
      <p>&nbsp;</p>
      <p>特此委托！</p>
      <p>&nbsp;</p>
      <P style="padding-left: 10%;">
        （签字）：<span class="underline minWidth">{{ form.driverName }}</span>
      </P>
      <P style="padding-left: 10%;">
        日期：<span class="underline">{{ form.year }}</span>年<span class="underline">{{ form.mon }}</span>月<span class="underline">{{ form.day }}</span>日
      </P>
    </vue-easy-print>
    <!--<el-button style="float:right;margin-top:100px" @click="printBtn()">打印</el-button>-->
  </div>
</template>
<script>
  import request from '@/utils/request'
  export default {
    data() {
      return {
        form: {},
      };
    },
    created() {
      let code = this.$route.query.code ? this.$route.query.code : "";
      let type = this.$route.query.type ? this.$route.query.type : "";
      let params = {};
      let path = 'acceptVehicle';
      if(type=='log'){
        path = 'acceptVehicleCollectionLog';
      }else{
        params.type = type;
      }
      this.init(path,code,params);
    },
    methods: {
      init(path,code,params) {
        if(path&&code){
          request({ url: `/ntocc-tms-api/${path}/collection/${code}`, method: 'get', params: params}).then(response => {
            if(response.data){
              this.form = response.data;
            }
          });
        }
      }
    }
  };
</script>
<style type="text/scss" lang="scss" scoped>
  .underline{
    border-bottom:1px solid #000;
    padding:0 15px;
    min-width: 120px;
  }
  .minWidth{
    min-width: 120px;
    /*display: inline-block;*/
  }
</style>
